export function isEmpty(text){
    if(text === undefined || text === null || text === ''){
        return true;
    }
    return false;
}